<div class="report-model">
  <div class="report-model-header">
    <div class="info">
      <h3>{{isSaudiCheck ? ("reports.nearbyRentals" | translate ) : ("reports.nearbyRentalsAndOccupancy" | translate)}}</h3>
    </div>
  </div>
  <!-- <app-residential-detail-table
    class="rwi-propertyDetail-table nearby-rentals"
    [tableName]="'nearbyRentals'"
    [showLoader]="!nearByRentalAndOccupancyLoading"
    [tableColumns]="nearByRentalAndOccupancy"
    [tableData]="nearByRentalAndOccupancyData"
    [allowExcelDownload]="true"
    [hidePagination]="true"
    (excelDownload)="downloadExcel('property_details_residential_nearby_rentals_occupancy')"
    [downloadLoading]="reportPropertyDetailService.downloadLoading['f']"
  >
  </app-residential-detail-table> -->
</div>
